export default __webpack_public_path__ + "static/WorkQueueExample-915335b537759b43f70cd2eb7271212a.png";